import apiCallTemplate from './servicesConfig'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const royaltiesURL = `${BASE_URL}/wallet`;
const payRoyaltiesURL=`${BASE_URL}/payment`
//get all wallet
export const allRoyalties=async ()=>apiCallTemplate("get", royaltiesURL)

//create wallet for user
export const createRoyalaltiesAccount=async (id,data)=>apiCallTemplate("post", `${royaltiesURL}/create/${id}`, data)

//Get wallet by user id
export const getArtisteRoyaltiesAccount=async (id)=>apiCallTemplate("get", `${royaltiesURL}/my-wallet/${id}`)

//Get wallet by user id
export const getArtisteRoyaltiesInfo=async (id)=>apiCallTemplate("get", `${royaltiesURL}/user-wallet/${id}`)

//Update wallet
export const updateRoyaltiesAccount=async (data)=>apiCallTemplate("put", `${royaltiesURL}/update/my-wallet`, data)

//Delete wallet
export const deleteRoyaltiesAccount=async (id)=>apiCallTemplate("delete", `${royaltiesURL}/${id}`)

//Pay royalties
export const payRoyalties=async (id, data)=>apiCallTemplate("post", `${payRoyaltiesURL}/make-payment/${id}`, data)

//My Royalties history
export const royaltiesHistory=async ()=>apiCallTemplate("get", `${payRoyaltiesURL}`)

//My Royalties history
export const myRoyaltiesHistory=async ()=>apiCallTemplate("get", `${payRoyaltiesURL}/my-payment-history`)
